<template>
  <div class="wish" v-bind:class="{ tolate: (toLate && !show) }">
      <span v-if="wish.favorite" v-on:click="unfav" class="favorite fa fa-heart"></span>
      <span v-else-if="owner" v-on:click="fav" class="favorite fa fa-heart-o"></span>
        
      
      <!-- src="../assets/cadeau.jpg" -->
      <!-- <img class="pic" alt="Vue logo" src="../assets/cadeau.jpg"/> -->
      <div class="picbox">
        <img class="pic" v-on:click="$emit('describe', wish)" alt="visuel" :src="img"/>
        <p class="tolate" v-if="toLate && !show">Trop tard</p>
      </div>      
      <p class="wish-name">{{ wish.label }}</p>
      <p class="wish-price">{{ wish.price | formatNumber}}</p>
      <p class="booked" v-if="toLate && !show">réservé par {{ wish.reservation.reservationOwner }}</p>
      <div class="tools">
        <a title="lien" target="_blank" v-bind:href="wish.link"><i class="fa fa-globe"></i></a>
        <a title="réserver" v-on:click="book" v-if="! (owner || (toLate && !show))"><i class="fa fa-shopping-cart "></i></a>
        <a title="annuler la réservation" v-on:click="unbook" v-if="reservationOwner"><i class="fa fa-shopping-cart  red"></i></a>
        <a title="modifier" v-on:click="edit" v-if="owner || impersonate"><i class="fa fa-pencil "></i></a>
        <a title="supprimer" v-on:click="del" v-if="owner || impersonate"><i class="fa fa-trash "></i></a>
      </div>
      <div class="loading" v-if="loading"><p>Chargement ...</p></div>
  </div>
</template>

<script>

var numeral = require("numeral");
import Vue from 'vue'
Vue.filter("formatNumber", function (value) {
    return numeral(value/100).format("0.00") + "€";
});

// { "priority": 100, "owner": "David", "price": 1000, "id": "kdo1", "label": "A Super Cadeau" }
export default {
  props: ["wish","owner","impersonate","show"],
  data() {
      return {
        defaultImage: require("@/assets/cadeau.jpg"),
        loading: false
      }
  },
  beforeMount: function() {
    if(this.wish.favorite == "true" || this.wish.favorite == true){
      this.wish.favorite = true
    }else{ 
      this.wish.favorite = false
    }
  },
  computed: {
      img: function() {
          return (this.wish.picture === undefined) ? this.defaultImage : this.wish.picture 
      },
      toLate: function (){
          return this.wish.reservation !== undefined && this.wish.reservation !== null;
      },
      reservationOwner() {
          if(this.toLate) {
            return this.wish.reservation.reservationOwner == this.$oauth.getCurrentUser();
          }else {
            return false;
          }          
      },
      priceInEuro(){
        return (this.wish.price / 100) + " €"
      }
  },
  methods: {
    del() {
      let impersonate = undefined
      if(this.impersonate){
        impersonate = this.$route.params.user
      }
      this.$api.delete(this.wish.id, impersonate, this, function(component){
        component.$toast.open('Supprimé!');
        component.$emit('deleted', component.wish)
      })
    },
    save() {      
      let impersonate = undefined
      if(this.impersonate){
        impersonate = this.$route.params.user
      }
      var wish = {
          label: this.wish.label,
          price: this.priceInEuro,
          description: this.wish.description,
          link: this.wish.link,
          picture: this.wish.picture,
          size: this.wish.size,
          priority: parseInt(this.wish.priority, 10),
          favorite: this.wish.favorite,
      }
      this.$api.upsert(this.wish.id, wish, impersonate, this)
    },
    fav() {
      if(this.owner){
        this.wish.favorite = true
        this.save()
      }
    },
    unfav(){
      if(this.owner){
        this.wish.favorite = false
        this.save()
      }
    },
    edit() {  
      let path = '/add'
      if(this.impersonate){
        path = '/add/' + this.$route.params.user
      }
      var w = {
        id: this.wish.id,
        asin: "",
        label: {
          value: this.wish.label,
          hasError: false,
        },
        picture: this.wish.picture,
        description: this.wish.description,
        link: this.wish.link,
        price: {
          value: (this.wish.price/100) + " €",
          hasError: false,
        },
        size: this.wish.size,
        priority: this.wish.priority,
        favorite: this.wish.favorite
      }
      localStorage.setItem('wish_edit', JSON.stringify(w))

      this.$router.push({ path: path })
    },
    book() {
      this.loading = true
      this.$api.book(this.wish.id, this.$route.params.user, this, function(component){
        component.wish.reservation = {reservationOwner: component.$oauth.getCurrentUser()}
        component.loading = false
      })
    },
    unbook() {
      this.loading = true
      this.$api.unbook(this.wish.id, this.$route.params.user, this, function(component){
        component.wish.reservation = undefined
        component.loading = false
      })
    }
  }
}
</script>

<style>
a {
  text-decoration: none;
  color: inherit;
}

.favorite {
  position: absolute;
  top: 105px;
  left: 265px;
  z-index: 50;
  color: indianred;
}

.red {
    color:indianred;
}
.tolate {
  background-color: lightseagreen;
}

p.tolate {
    color: white;
    font-size: 1.5em;
    position: absolute;
    top: 0px;
    width: 190px;
    background-color: #20B2AA;
    margin-top: 49%
}

.picbox {
    position: relative;
    width: 190px;
    height: 190px;
    float: left;
    background-color: white;
    margin: 5px;
}
.tools a { 
    display: inline;
    padding: 0;
}
.fa {
    font-size: 36px;  
    padding-left: 5px;
    padding-right: 5px;
    display: inline;
}

.fa-price {
    font-size: 40px;
}
.tools {
    bottom: 5px;
    right: 41px;
    position: absolute;
}

.pic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    object-fit: contain;
}

.pic:hover {
  cursor: zoom-in;
}

.wish-name {
    padding-top: 10px;
    height: 3em;
    overflow: hidden;
}

.wish-price {
    padding-top: 10px;
    font-size: 24px;
}

.booked {
    padding-top: 10px;
    color: indianred;
    font-weight: bold;
}

.wish {
  margin: 5px;
  float: left;
  border: thin solid indianred;
  position: relative;
  height: 200px;
  width: 390px;
}

@media only screen and (max-width: 1024px) {
  .wish {
    width: 360px;
  }
}

@media only screen and (max-width: 600px) {
  .wish {
    min-width: 360px;
    width: 97%;
  }
}

.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 100;
  text-align: center;
  background-color: white;
}

.loading p {
  font-size: 1.5em;
  margin-top: 75px;
}
</style>